"use client";
import { Button } from "@/app/_module/components/ui/button";
import {
  Dialog,
  ResponsiveDialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/app/_module/components/ui/dialog";

interface ConfirmDeleteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
}

const ConfirmDeleteModal = function({
  open,
  onOpenChange,
  onConfirm,
  title = "Delete Resource",
  description = "Are you sure you want to delete this resource? This action cannot be undone.",
}: ConfirmDeleteModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <ResponsiveDialogContent size="md">
        <DialogHeader>
          <DialogTitle className="pb-4 text-xl font-bold">{title}</DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button className="px-6 cursor-pointer" onClick={() => onOpenChange(false)} variant="outline">
            Cancel
          </Button>
          <Button className="px-6 cursor-pointer" onClick={handleConfirm} variant="destructive">
            Delete
          </Button>
        </DialogFooter>
      </ResponsiveDialogContent>
    </Dialog>
  );
}

export default ConfirmDeleteModal;
